import ContentCardV4 from '../../common/component/ContentCardV4';
import EllipsisText from '../../common/component/EllipsisText';
import {IEventContentCardV4} from '../type';

interface IProps {
  content: IEventContentCardV4;
  onClickContent: (content: IEventContentCardV4) => void;
}

export default function EventContentCardV4({content, onClickContent}: IProps) {
  const {descLine2} = content;

  const handleClickContent = () => {
    onClickContent?.(content);
  };

  return (
    <ContentCardV4
      content={content}
      onClick={handleClickContent}
      titleImageClassName="gap-y-8 !bottom-16"
      titleImageBottomElement={
        <EllipsisText
          line={2}
          className={cn(
            'opacity-70 px-10',
            's12-medium-white leading-16 tracking-[-0.24px]'
          )}
        >
          {descLine2}
        </EllipsisText>
      }
    />
  );
}
